import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { IoCloseOutline, IoTrashOutline, IoArrowForward, IoBagHandleOutline } from 'react-icons/io5';
import styles from './FloatingCart.module.scss';
import { useCart } from '../../../context/CartContext';

const BACKEND_URL = 'https://huongtramcomoc.vn';
const PLACEHOLDER_IMAGE = '/images/placeholder.jpg';

const FloatingCart = () => {
  // Lấy data và các hàm tính toán trực tiếp từ Context
  const { cartItems, removeFromCart, getCartTotal, calculateFinalPrice } = useCart();
  
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const cartRef = useRef(null);
  const prevCountRef = useRef(0);

  // Tính tổng số lượng item
  const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);
  
  // Tính tổng tiền (Sử dụng hàm của Context để đảm bảo chính xác)
  const totalAmount = getCartTotal();

  // Hàm format tiền tệ hiển thị (VND)
  const formatPrice = (price) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
  };

  // --- HIỆU ỨNG NẢY (BOUNCE) KHI THÊM SẢN PHẨM ---
  useEffect(() => {
    if (totalItems > prevCountRef.current) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 600); 
      return () => clearTimeout(timer);
    }
    prevCountRef.current = totalItems;
  }, [totalItems]);

  // Click ra ngoài thì đóng
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [cartRef]);

  return (
    <div className={styles.wrapper} ref={cartRef}>
      
      {/* NÚT TRÒN TRÔI NỔI */}
      <button 
        className={`
          ${styles.floatBtn} 
          ${isOpen ? styles.active : ''} 
          ${isAnimating ? styles.bounce : ''} 
        `} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={styles.iconContainer}>
          {isOpen ? <IoCloseOutline /> : <IoBagHandleOutline />}
        </div>
        {totalItems > 0 && !isOpen && <span className={styles.badge}>{totalItems}</span>}
      </button>

      {/* CỬA SỔ MINI CART */}
      <div className={`${styles.miniCart} ${isOpen ? styles.open : ''}`}>
        
        {/* Header */}
        <div className={styles.header}>
          <h3>Giỏ hàng <span>({totalItems} sản phẩm)</span></h3>
          <button className={styles.closeBtn} onClick={() => setIsOpen(false)}>
            <IoCloseOutline />
          </button>
        </div>

        {/* Body */}
        <div className={styles.body}>
          {cartItems.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}><IoBagHandleOutline /></div>
              <p>Giỏ hàng chưa có sản phẩm</p>
            </div>
          ) : (
            <ul className={styles.list}>
              {cartItems.map((item) => {
                 const finalPrice = calculateFinalPrice(item);
                 const imageUrl = item.thumbnail_url 
                  ? (item.thumbnail_url.startsWith('http') ? item.thumbnail_url : `${BACKEND_URL}${item.thumbnail_url}`)
                  : PLACEHOLDER_IMAGE;
                 return (
                  <li key={item.id} className={styles.item}>
                    <div className={styles.imgThumb}>
                      <img 
                        src={imageUrl} 
                        alt={item.name} 
                      />
                    </div>
                    
                    <div className={styles.info}>
                      <Link to={`/san-pham/${item.id}`} className={styles.name} onClick={() => setIsOpen(false)}>
                        {item.name}
                      </Link>
                      
                      <div className={styles.meta}>
                        <span className={styles.qty}>x{item.quantity}</span>
                        <span className={styles.price}>{formatPrice(finalPrice)}</span>
                      </div>
                    </div>

                    <button 
                      className={styles.removeBtn} 
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFromCart(item.id);
                      }}
                      title="Xóa"
                    >
                      <IoTrashOutline />
                    </button>
                  </li>
                 );
              })}
            </ul>
          )}
        </div>

        {/* Footer */}
        {cartItems.length > 0 && (
          <div className={styles.footer}>
            <div className={styles.totalRow}>
              <span>Tạm tính:</span>
              <span className={styles.totalVal}>{formatPrice(totalAmount)}</span>
            </div>
            <Link to="/gio-hang" className={styles.checkoutBtn} onClick={() => setIsOpen(false)}>
              TIẾN HÀNH THANH TOÁN <IoArrowForward />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingCart;